import './orchestra.css';
import React, { useState } from "react";
import Slider from "react-slick";

const ImageWithPlaceholder = ({ src, alt }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className="orch-wrapper">
            {!loaded && <div className="orch-placeholder"></div>}
            <img
                src={src}
                alt={alt}
                className={`orch-img ${loaded ? 'loaded' : ''}`}
                onLoad={() => setLoaded(true)}
            />
        </div>
    );
};

const Orchestra = () =>{
    const settings = {
        dots: true,
        lazyLoad: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        arrows: true,
        adaptiveHeight: true, // 슬라이더 높이 조정
      };

return(
    <div className="orch">
        <>
        <h3>오케스트라</h3>
        <div className='orch-slider'>
                <Slider {...settings}>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/JhgChPf.png" alt='오케스트라' />
                    </div>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/nyjJIsu.png" alt='오케스트라' />
                    </div>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/vrb5Erw.png" alt='오케스트라' />
                    </div>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/mvakb7U.png" alt='오케스트라' />
                    </div>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/cEJyRJJ.png" alt='오케스트라' />
                    </div>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/Uu10u8m.png" alt='오케스트라' />
                    </div>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/jhX4GKU.png" alt='오케스트라' />
                    </div>
                    <div>
                        <ImageWithPlaceholder src = "https://imgur.com/l2X3qc2.png" alt='오케스트라' />
                    </div>
                </Slider>
            </div>
        <div className="orch_box">
                <h4>
                코리아하모니카오케스트라
                <br/>
                KHO(Korea Harmonica Orchestra)
                </h4>
                <div>
                코리아하모니카 오케스트라는 한국하모니카교육협회 소속 연주단으로서 2002년 4월 발족하였습니다. <br/>
                성인 오케스트라, 시니어 오케스트라, 유스 오케스트라로 구성되어 있으며, 하모니카 음악의 발전을 목표로 각종 음악회와 대회에서 활발히 활동하며 다수의 수상 경력을 보유하고 있습니다.<br/>
                <br/>
                <strong>수상 경력</strong>
                <ul>
                    <li>2016 제3회 생활예술오케스트라 축제 1위</li>
                    <li>2017 제5회 SIHF 대합주 성인부 1위 / 시니어부 2위</li>
                    <li>2017 제4회 생활예술오케스트라 축제 1위</li>
                    <li>2018 제6회 SIHF 대합주 성인부 1위 / 시니어부 1위</li>
                    <li>2019 제7회 SIHF 대합주 성인부 3위 / 시니어부 1위</li>
                </ul>
                
                <strong>주요 공연 활동</strong>
                <ul>
                    <li>2016 제11회 아시아 태평양 하모니카 페스티벌 개막식 공연</li>
                    <li>2016 '서울 문화의 밤' 초청 공연</li>
                    <li>2017 생활예술제 '모두를 위한 오케스트라'</li>
                    <li>2017 7017 서울로 개막 축제 초청 공연</li>
                    <li>2017 영등포아트홀 초청 공연 'WEISSENBERG와 함께하는 하모니카 칸타빌레'</li>
                    <li>2018 생활예술제 '모두를 위한 오케스트라'</li>
                    <li>2019 서울시 주최 3.1운동 백주년 기념 공연 참가</li>
                    <li>2019 SIHF 갈라 콘서트 출연</li>
                </ul>
                </div>
            </div>
            <div className='orch_box'>
                <h4>코리아시니어하모니카 오케스트라<br/>
                KHO (Korea Senior Harmonica Orchestra)</h4>
                <div>
                코리아시니어하모니카오케스트라는 노년층에게 제2의 인생 무대를 제공하고, 하모니카 음악의 저변 확대를 목적으로 2016년 12월 발족하였습니다.
                60세 이상의 연주자로 구성되어 있으며, 창단 이래 활발한 연주 활동을 통해 연주 경력과 수상 경력을 쌓아가고 있으며, 문화 소외 계층을 위한 자선 활동도 활발히 하고 있습니다.
                <br/>
                <br/>
                <strong> 수상 경력 및 주요 활동</strong>
                    <ul>
                        <li>2017년 제5회 서울 국제하모니카 오케스트라 노년부 부문 2위 수상</li>
                        <li>2017년 부천시 주최 하모니카 장르 부문 출연</li>
                        <li>2018년 세종문화회관 주최 (제4회 서울 국제 생활예술오케스트라 축제) 본선 경연 출연</li>
                    </ul>
                </div>
            </div>
            <div className='orch_box'>
                <h4>코리아유스하모니카 오케스트라<br/>
                KHO (Korea Youth Harmonica Orchestra)</h4>
                <div>
                코리아유스하모니카오케스트라는 2002년 4월에 발족한 청소년 하모니카 오케스트라로서, 청소년들에게 진로 탐색의 기회를 제공하고, 음악을 통해 학업 스트레스를 해소할 수 있는 길을 열어주고자 창단되었습니다.<br/>
                수많은 젊은 연주자들을 양성하고 있으며, 이들 중 다수가 전문 연주자로서 활발히 활동하고 있습니다.<br/>

                
                <br/><strong>수상 경력</strong>
                <ul>
                    <li>
                    2016~2017년 서울 하모니카 페스티벌 오케스트라 청소년 부문 1위 수상
                    </li>
                </ul>
                </div>
            </div>
        </>
    </div>
)
}
export default Orchestra;